<template>
  <div id="header" class="home">
    <div class="wrapper">
      
      <div class="textBox">
        <div>
          <img src="../assets/gagganLogoWhite.svg" alt="">
        </div>

        <router-link to="/ideaology" class="mainBtn">Ideaology</router-link>
        <router-link to="/ourStory" class="mainBtn brown">About Us</router-link>
      </div>

      <p class="coordinates">
        <a href="https://goo.gl/maps/ZhJJewSts7yLyWk29" target="_blank">13.7376° N, 100.5422° E</a>
      </p>

      <div class="bestRestaurant">
        <a href="https://www.theworlds50best.com/list/1-50-winners" target="_blank">
          <img src="../assets/awards.png" alt />
        </a>
      </div>

    </div>

    <div id="myVideo">
      <video autobuffer autoplay loop muted playsinline>
        <source src="../assets/intro.mp4" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  data() {
    return {

    }
  },
  methods: {

  }
};
</script>

<style src="../styles/main.scss" lang="scss">
</style>

